import type { Dispatch, AnyAction } from 'redux';

import * as CreateReportTypeAPI from 'ab-api/web/reportType/create';
import * as EditReportTypeAPI from 'ab-api/web/reportType/edit';
import * as EditReportRequiredStatusAPI from 'ab-api/web/reportType/editReportRequiredStatus';
import * as FindReportTypeAPI from 'ab-api/web/reportType/find';
import * as FindAllActiveAPI from 'ab-api/web/reportType/findAllActive';
import * as FindAllForFilterAPI from 'ab-api/web/reportType/findAllForFilter';
import * as FindReportBlockFieldsForFilterAPI from 'ab-api/web/reportType/findAllReportBlockFieldsForFilter';
import * as FindCustomActiveAPI from 'ab-api/web/reportType/findCustomActive';
import * as FindRequiredActiveAPI from 'ab-api/web/reportType/findRequiredActive';

import type { CustomReportTypeTableRowVM } from 'ab-viewModels/reportType/reportTypeTable.viewModel';

import type { ReportTypeStatus } from '@acceligentllc/shared/enums/reportTypeStatus';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

import type { TableContent } from 'ab-common/dataStructures/tableContent';
import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

export function findTable(tableRequestModel: TableQuery) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<TableContent<CustomReportTypeTableRowVM>>(API.V1.COMPANY.REPORT_TYPE.FIND_TABLE(tableRequestModel));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findCustomShallowActiveList() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			const result = await http.get<FindCustomActiveAPI.W_ReportType_FindCustomActive_VM>(FindCustomActiveAPI.URL());
			return result.reportTypes;
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findRequiredShallowActiveList() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			const result = await http.get<FindRequiredActiveAPI.W_ReportType_FindRequiredActive_VM>(FindRequiredActiveAPI.URL());
			return result.reportTypes;
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findAllShallowActiveList() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			const result = await http.get<FindAllActiveAPI.W_ReportType_FindAllActive_VM>(FindAllActiveAPI.URL());
			return result.reportTypes;
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findCustomById(id: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<FindReportTypeAPI.W_ReportType_Find_VM>(FindReportTypeAPI.URL(id));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function createCustom(form: CreateReportTypeAPI.W_ReportType_Create_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.post(CreateReportTypeAPI.URL(), form);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function editCustom(id: number, form: EditReportTypeAPI.W_ReportType_Edit_RM) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.put(EditReportTypeAPI.URL(id), form);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function editCustomStatus(id: number, status: ReportTypeStatus) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.put(API.V1.COMPANY.REPORT_TYPE.EDIT_STATUS(id), { status });
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function editReportRequiredStatus(id: number, isRequired: boolean) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.put(EditReportRequiredStatusAPI.URL(id), { isRequired });
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function deleteCustom(id: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.delete(API.V1.COMPANY.REPORT_TYPE.DELETE(id));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function getAllForReportTypeFilter() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindAllForFilterAPI.W_ReportType_FindAllReportTypesForFilter_VM>(FindAllForFilterAPI.URL());
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function getReportBlockFieldsForFilter(reportTypeId: number, startDate: string, endDate: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<FindReportBlockFieldsForFilterAPI.W_ReportType_FindAllReportBlockFieldsForFilter_VM>(
				FindReportBlockFieldsForFilterAPI.URL(reportTypeId, startDate, endDate)
			);
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
